import { Fragment, useState } from "react";
import { Mui } from "@osu/react-ui";
import SessionFormModal from "./Form";
import { useUpdateSessionMutation } from "../../../../../services/submissionPeriod/api";

function AdminDatesEditModal({ fullWidth = true, maxWidth = "md", year, period, children, session = {}, ...rest }) {
  const [updateSession, {
    isLoading
  }] = useUpdateSessionMutation()
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };  
  const handleSubmit = async (sessionData) => {
    try {
      const { formData = {} } = sessionData || {}
      const payload = {
        ...formData,
        pk: formData?.pk || session?.pk,
        sk: formData?.sk || session?.sk,
        year,
        period
      }
      updateSession(payload)
      setOpen(false);
    } catch (error) {
      console.error("Error saving session:", error);
    }
  };
  const openModal = open || isLoading

  return (
    <Fragment>
      <Mui.Button {...rest} onClick={handleClickOpen} variant="outlined">
        {children}
      </Mui.Button>
      <Mui.Dialog
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        open={openModal}
        onClose={handleClose}
      >
        <SessionFormModal
          isSaving={isLoading}
          open={openModal}
          onClose={handleClose}
          onSubmit={handleSubmit}
          year={year}
          period={period}
          session={session}
        />
      </Mui.Dialog>
    </Fragment>
  );
}

export default AdminDatesEditModal;
